export default __webpack_public_path__ + "static/media/danger.5376a9ee.svg";